import {BijbError} from '../../models/bijb-error';
import {EnclosureCard} from '../../models/enclosure-card';
import {LoadableState} from './loadable-state';
import {autoserializeAs, autoserializeIndexable, inheritSerialization} from 'cerialize';

@inheritSerialization(LoadableState)
export class EnclosureCardsState extends LoadableState {
  public static readonly key = 'EnclosureCardsState';

  @autoserializeIndexable(EnclosureCard, 'enclosureCards')
  public enclosureCards: { [groupId: number]: EnclosureCard } = {};

  @autoserializeAs(BijbError, 'error')
  public error: BijbError = null;
}
